// Loan Compliance Module v1.0 PR 3 — derived-state chip for a Legal Ops
// module. Reads the LegalOpsModuleStatusDto.derivedState string off the
// PR 2 GetModuleStatusesAsync response.

import { Badge } from "@/design-system/components/ui";

interface ModuleStatusChipProps {
  /** "OnTrack" | "Due" | "Overdue" | "NotYetChecked" | "Exception" */
  state: string;
}

const CHIP: Record<
  string,
  { tone: "finalized" | "review" | "error" | "archived"; label: string }
> = {
  OnTrack: { tone: "finalized", label: "On track" },
  Due: { tone: "review", label: "Due" },
  Overdue: { tone: "error", label: "Overdue" },
  NotYetChecked: { tone: "archived", label: "Not yet checked" },
  Exception: { tone: "error", label: "Exception" },
};

export function ModuleStatusChip({ state }: ModuleStatusChipProps) {
  const meta = CHIP[state] ?? CHIP.NotYetChecked;
  return (
    <Badge status={meta.tone} data-testid={`legal-ops-status-${state}`}>
      {meta.label}
    </Badge>
  );
}
